import { KLYDO_WHITE } from '../../../consts/colors';
import DSAppBar from '../../../design-system/DSAppBar';
import DSAvatar from '../../../design-system/DSAvatar';
import DSBox from '../../../design-system/DSBox';
import DSToolbar from '../../../design-system/DSToolbar';
import { DSTypography } from '../../../design-system/Typography';
import useAppBar from '../hooks/useAppBar';
import logo from '../../../images/klydo-studio-beta-logo.svg';
import { APPBAR_HIGHT } from '../../../consts/general';
import UserDropdown from './UserDropdown';
import DSChip from '../../../design-system/DSChip';
import { useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getScaledCloudinaryUrl } from '../../../utils';

const AppBar = () => {
  const {
    user,
    isTablet,
    shouldShowUserDropdown,
    shouldShowImpersonatingChip,
    stopImpersonating,
  } = useAppBar();

  const { spacing, palette, zIndex } = useTheme();
  const navigate = useNavigate();

  return (
    <DSAppBar
      position="fixed"
      elevation={0}
      sx={{
        height: spacing(APPBAR_HIGHT),
        backgroundColor: palette.background.default,
        p: spacing(1),
        zIndex: zIndex.appBar,
      }}
    >
      <DSToolbar
        sx={{
          justifyContent: 'space-between',
          backgroundColor: palette.background.default,
        }}
      >
        <DSBox
          sx={{
            display: 'flex',
            alignItems: 'center',
            marginLeft: { xxs: spacing(5), lg: 0 },
          }}
        >
          <img
            onClick={() => navigate('/')}
            src={logo}
            alt="Logo"
            width={isTablet ? spacing(15) : spacing(22)}
            height={'auto'}
            style={{ cursor: 'pointer' }}
          />

          {shouldShowUserDropdown && <UserDropdown />}
          {shouldShowImpersonatingChip && (
            <DSChip
              label={'Impersonating'}
              onClick={() => stopImpersonating()}
              sx={{
                ml: spacing(2),
              }}
            />
          )}
        </DSBox>

        <DSBox sx={{ display: 'flex', alignItems: 'center', gap: spacing(2) }}>
          {!isTablet && (
            <DSTypography
              variant="subtitle1"
              color={KLYDO_WHITE}
              fontSize={spacing(2)}
              onClick={() => navigate('/artist-page')}
              sx={{ cursor: 'pointer' }}
            >
              {user?.name}
            </DSTypography>
          )}
          <DSAvatar
            alt="Profile Avatar"
            src={
              user?.photoUrl
                ? getScaledCloudinaryUrl(user.photoUrl, 96)
                : undefined
            }
            onClick={() => navigate('/artist-page')}
            sx={{
              width: { xs: spacing(5), md: spacing(6) },
              height: { xs: spacing(5), md: spacing(6) },
              cursor: 'pointer',
            }}
          />
        </DSBox>
      </DSToolbar>
    </DSAppBar>
  );
};
export default AppBar;
